import { Injectable, type Signal, signal } from '@angular/core';

/** What the user menu needs to offer the *System Domain* entry. */
interface SystemDomainMenuEntry {
	readonly systemDomainId: string;
}

/**
 * The one link between the user menu and Clarity's System Domain recognition (the System Domain port,
 * spec §3; ticket 12 §4).
 *
 * The menu sits in the platform shell, above every section, and cannot see a single Clarity provider —
 * they are bound on the `/clarity` route and must stay there, or the Clarity chunk moves into the initial
 * one. So this root service holds only a value, `{ systemDomainId } | null`, and knows nothing about how it
 * is decided: no HTTP, no Clarity import. The Clarity composition root fills it from recognition, which
 * answers an id only while the section is active, the role is exactly `admin` and the System Domain is
 * recognised — losing any one of the three clears it.
 */
@Injectable({ providedIn: 'root' })
export class SystemDomainMenuBridgeService {
	private readonly current = signal<SystemDomainMenuEntry | null>(null);

	/** The entry to offer, or `null` while the menu must not show it. */
	public readonly entry: Signal<SystemDomainMenuEntry | null> = this.current.asReadonly();

	public set(entry: SystemDomainMenuEntry | null): void {
		this.current.set(entry);
	}
}
